import PropTypes from 'prop-types';
import { Button } from '@bwoty-web/styleguide';
import { FlightHit } from '../FlightHit';
import styles from './ResultList.scss';

export function ResultList(props) {
  const { offers, texts, orderBy, hasMore, showLoading, isFetching, onLoadMore, onBuildUpsellUrl } =
    props;

  return (
    <div className={styles.root}>
      {offers.map((offer) => {
        return (
          <FlightHit
            key={offer.key}
            node={offer.node}
            texts={texts}
            orderBy={orderBy}
            isLoading={showLoading}
            onBuildUpsellUrl={onBuildUpsellUrl}
          />
        );
      })}
      {hasMore ? (
        <div className={styles.loadMore}>
          <Button
            theme="primary"
            onClick={onLoadMore}
            disabled={isFetching || showLoading}
            loading={isFetching}
          >
            {texts.showMoreTrips}
          </Button>
        </div>
      ) : null}
    </div>
  );
}

ResultList.propTypes = {
  hasMore: PropTypes.bool,
  showLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
  texts: PropTypes.object,
  orderBy: PropTypes.string,
  offers: PropTypes.array,
  onLoadMore: PropTypes.func,
  onBuildUpsellUrl: PropTypes.func,
};
